import React, { useContext } from 'react';
import { makeStyles } from 'tss-react/mui';
import EditableAttribute from '../../../../../../../../../../../Components/Attributes/EditableAttribute/EditableAttribute';
import {
  getAssociationSafe,
  getAttributeSafe,
} from '../../../../../../../../../../../Components/Urval/Utils/urvalUtils';
import clientAvenyModel from '../../../../../../../../../../../Model/clientAvenyModel';
import { ModelContext } from '../../../../../../../../../../../Model/ModelContext/ModelContext';
import { IClientBusinessModel } from '../../../../../../../../../../../Types/ClientModelTypes';
import { BusinessDataFormContext } from '../../../../../../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/BusinessDataForm';
import {
  IKontodelDef,
  IKontodelTillaggsinfo,
} from '../../../../../../../../../_Common/Components/KonteringManager/Query/KonteringManagerQuery';
import {
  FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Konteringsforslag_All,
  FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Konteringsforslag_All__Associations_Kontodel1,
} from '../../../../../../Queries/_QueryTypes/FakturaDelQuery';
import { AssociationChoice } from '../../../../../../../../../_Common/Components/BusinessCollectionComponents/AssociationChoice/AssociationChoice';
import EDRadioGroup, {
  IRadioDef,
} from '../../../../../../../../../../../BaseComponents/RadioGroup/EDRadioGroup';
import { ObjektLank } from '../../../../../../../../../_Common/Components/BusinessCollectionComponents/ObjektLank/ObjektLank';
import { findCollection } from '../../../../../../../../../../../Model/avenyModelUtils';
import { useQuery } from '@apollo/client';
import { TillaggsinfoQuery } from '../../Queries/_QueryTypes/TillaggsinfoQuery';
import { ActiveDatabaseContext } from '../../../../../../../../../../../Components/ActiveDatabaseContext/ActiveDatabaseContext';
import { businessDataFormValuesEqual } from '../../../../../../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/BusinessDataFormHasChanged/businessDataFormHasChanged';
import { getTillaggsinfoValidationErrorMessageFn } from '../../Utils/TillaggsinfoUtils';
import shortid from 'shortid';
import { TEDSelectionOperator } from '../../../../../../../../../../../globalQueryTypes';
import { EDAutoCompleteEdit } from '../../../../../../../../../../../BaseComponents/AutoCompleteEdit/EDAutoCompleteEdit';
import ServerError from '../../../../../../../../../../../Components/ServerError/ServerError';
import {
  FormUpdateAssociatonType,
  MutationOperation,
} from '../../../../../../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormValueUtils';
import EDTypography from '../../../../../../../../../../../BaseComponents/Typography/EDTypography';
import EDCaptionedValue from '../../../../../../../../../../../BaseComponents/CaptionedValue/EDCaptionedValue';
import DisplayText from '../../../../../../../../../../../Components/Attributes/DisplayText/DisplayText';
import { TEDFormatDefault } from '../../../../../../../../../../../Utils/Formatters/FormatterClasses/TEDFormatDefault';
import { ValueType } from '../../../../../../../../../../../Utils/Formatters/FormatterTypes';
import {
  TillgangAvskrkontoDebQuery,
  TillgangAvskrkontoDebQueryVariables,
} from '../../Queries/_QueryTypes/TillgangAvskrkontoDebQuery';
import TillgangAvskrkontoDebQueryDoc from '../../Queries/TillgangAvskrkontoDebQuery.gql';
import { formatDate } from '../../../../../../../../../../../Utils/dateUtils';
import { IFieldValidations } from '../../../../../../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormUtils';
import EDBox from '../../../../../../../../../../../BaseComponents/EDBox/EDBox';
import { useIsSmallScreen } from '../../../../../../../../../../../Hooks/useFullscreenView';

enum NewBuildingValues {
  new = 'Y',
  old = 'N',
}

interface IProps {
  avskrivningKontodelOrdningsnummerList: number[];
  data: TillaggsinfoQuery | undefined;
  fakturaBokfDatum: Date;
  isKomponent: boolean;
  konteringsforslagDisabled: boolean;
  konteringsforslagUpdateId: string;
  konteringsforslagUpdateOperation:
    | MutationOperation.Add_Values
    | MutationOperation.Update_Values;
  kontodelsDef: IKontodelDef[];
  onFieldValueChange: (
    fieldname: string
  ) => (
    newValue: any,
    validationErrorMessage?: IFieldValidations | undefined
  ) => void;
  originKonteringsforslag: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Konteringsforslag_All | null;
  tillaggsinfo: IKontodelTillaggsinfo;
  updatedKonteringsforslag: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Konteringsforslag_All;
}

interface IAvskrivningKontodelOption {
  name: string;
  value: string;
  benamning: string | null;
  id: string;
}

const useStyles = makeStyles()(theme => ({
  avskrivsPaLabel: { marginLeft: theme.spacing(1) },
  avskrivsPaContainer: {
    width: '100%',
    margin: `${theme.spacing(2)} 0 0 0`,
  },
  avskrivsPaKoddelarContainer: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
  },
  avskrivsPaKoddel: {
    boxSizing: 'border-box',
    flex: '0 1 100%',
    [theme.breakpoints.up('lg')]: {
      flex: '0 1 50%',
    },
  },
}));

const konteringsforslagModel: IClientBusinessModel =
  clientAvenyModel.LR.BusinessModels.LRKonteringsForslag;

const AdditionalInformation: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const { classes } = useStyles();
  const modelContext = useContext(ModelContext);
  const dataForm = useContext(BusinessDataFormContext);
  const activeDatabaseContext = useContext(ActiveDatabaseContext);
  const isSmallScreen = useIsSmallScreen();

  const skipTillgangAvskrkontoDebQuery =
    props.updatedKonteringsforslag._Associations?.Tillgang?.RuleID == null ||
    !activeDatabaseContext.activeDatabase;
  const {
    data: tillgangAvskrkontoDebQueryData,
    loading: tillgangAvskrkontoDebQueryLoading,
    error: tillgangAvskrkontoDebQueryError,
  } = useQuery<TillgangAvskrkontoDebQuery, TillgangAvskrkontoDebQueryVariables>(
    TillgangAvskrkontoDebQueryDoc,
    {
      variables: {
        dbName: activeDatabaseContext.activeDatabase ?? '',
        datum: formatDate(props.fakturaBokfDatum),
        datumAr: props.fakturaBokfDatum.getFullYear().toString(),
        tillgangRuleId:
          props.updatedKonteringsforslag._Associations?.Tillgang?.RuleID ?? '',
      },
      skip: skipTillgangAvskrkontoDebQuery,
    }
  );

  const avskrivningsKontoDelDefs: IKontodelDef[] =
    props.avskrivningKontodelOrdningsnummerList.reduce(
      (kontodelArray, avskrivningskontoOrdningsnummer) => {
        const kontodelsDef = props.kontodelsDef.find(
          kontodel => kontodel.ordningsNr === avskrivningskontoOrdningsnummer
        );

        if (!kontodelsDef) {
          throw new Error(
            `Kunde inte hitta kontodel med ordningsnummer ${avskrivningskontoOrdningsnummer}`
          );
        }

        if (kontodelsDef && kontodelsDef.kontodelar.length > 0) {
          return [...kontodelArray, kontodelsDef];
        } else {
          return kontodelArray;
        }
      },
      [] as IKontodelDef[]
    );

  const radioDefs: IRadioDef[] = [
    {
      label: props.isKomponent
        ? 'Befintlig byggnad'
        : 'Befintlig maskin/inventarie',
      value: NewBuildingValues.old,
    },
    {
      label: props.isKomponent ? 'Ny byggnad' : 'Ny maskin/inventarie',
      value: NewBuildingValues.new,
    },
  ];

  // Tilläggsinfo för byggnader/Investeringar

  const komponentbenamningAttribute = getAttributeSafe(
    'LRKonteringsForslag',
    'AR_BENAMNING',
    modelContext.avenyCollectionMap
  );
  const komponentbenamningField = props.tillaggsinfo.falt.find(
    field => field.fieldName === 'AR_BENAMNING'
  );

  const komponenttypField = props.tillaggsinfo.falt.find(
    field => field.fieldName === 'AR_KOMPONENT_ID'
  );

  const avskrivningstidAttribute = getAttributeSafe(
    'LRKonteringsForslag',
    'AR_AVSKR_TID',
    modelContext.avenyCollectionMap
  );
  const avskrivningstidField = props.tillaggsinfo.falt.find(
    field => field.fieldName === 'AR_AVSKR_TID'
  );

  const invdatumAttribute = getAttributeSafe(
    'LRKonteringsForslag',
    'AR_INV_DATUM',
    modelContext.avenyCollectionMap
  );
  const invdatumField = props.tillaggsinfo.falt.find(
    field => field.fieldName === 'AR_INV_DATUM'
  );

  const tillgangbenamningAttribute = getAttributeSafe(
    'LRKonteringsForslag',
    'AR_TILLGANG_BEN',
    modelContext.avenyCollectionMap
  );
  const tillgangField = props.tillaggsinfo.falt.find(
    field => field.fieldName === 'AR_TILLGANG'
  );

  const omradeField = props.tillaggsinfo.falt.find(
    field => field.fieldName === 'AR_OMRADE_ID'
  );

  const avskrivningskontoField = props.tillaggsinfo.falt.find(
    field => field.fieldName === 'AR_AVSKR_KDEL'
  );

  const kommentarAttribute = getAttributeSafe(
    'LRKonteringsForslag',
    'AR_KOMMENTAR',
    modelContext.avenyCollectionMap
  );
  const kommentarField = props.tillaggsinfo.falt.find(
    field => field.fieldName === 'AR_KOMMENTAR'
  );

  const konteringsforslagCollection = findCollection(
    modelContext.avenyCollectionMap,
    'LRKonteringsForslag'
  );
  const tillgangCollection = findCollection(
    modelContext.avenyCollectionMap,
    'ARTillgang'
  );

  if (!konteringsforslagCollection) {
    return null;
  }

  const isNewBuilding = Boolean(props.updatedKonteringsforslag.AR_NY);

  const attrHasChanged = (attributeName: string) =>
    !businessDataFormValuesEqual(
      (props.updatedKonteringsforslag as unknown as Record<string, ValueType>)[attributeName],
      (props?.originKonteringsforslag as unknown as Record<string, ValueType> | undefined)?.[attributeName]
    );

  const getErrorMessage = dataForm
    ? getTillaggsinfoValidationErrorMessageFn(
        dataForm.formState.validation,
        props.updatedKonteringsforslag.id
      )
    : () => undefined;

  // För att filtrera listan av tillgångar
  const rubrikAssociation = getAssociationSafe(
    'ARTillgang',
    'Rubrik',
    modelContext.avenyCollectionMap
  );

  const arRubrikIdAttribute = getAttributeSafe(
    'ARRubrik',
    'AR_RUBRIK_ID',
    modelContext.avenyCollectionMap
  );

  const platsTypAttribute = getAttributeSafe(
    'ARPlats',
    '_typ',
    modelContext.avenyCollectionMap
  );

  // För kontering
  const konteringsvardeCollection = findCollection(
    modelContext.avenyCollectionMap,
    'EKKonteringsvarde'
  );

  if (!konteringsvardeCollection) {
    return null;
  }

  return (
    <>
      {komponentbenamningField?.aktiv && (
        <EditableAttribute
          collection={konteringsforslagModel}
          attribute={komponentbenamningAttribute}
          key={komponentbenamningField.fieldName}
          label={komponentbenamningField.benamning}
          onChange={props.onFieldValueChange(komponentbenamningField.fieldName)}
          value={
            (props.updatedKonteringsforslag as unknown as Record<string, ValueType>)[komponentbenamningField.fieldName]
          }
          editMode
          marker={attrHasChanged(komponentbenamningField.fieldName)}
          required={komponentbenamningField.obligatorisk}
          size="large"
          tooltip={komponentbenamningField.beskrivning ?? undefined}
          disabled={props.konteringsforslagDisabled}
          errorMessage={getErrorMessage(komponentbenamningField.fieldName)}
        />
      )}
      {komponenttypField?.aktiv && (
        <AssociationChoice
          collectionName="ARKomponent"
          label={komponenttypField.benamning}
          onAssociationSelected={suggestion => {
            if (dataForm) {
              dataForm.update([
                {
                  operation: 'Ref',
                  associationName: 'Komponenttyp',
                  values: {
                    id: suggestion?.value,
                  },
                },
              ]);
            }
          }}
          value={
            props.updatedKonteringsforslag._Associations?.Komponenttyp?.id || ''
          }
          headerDefs={['BENAMNING']}
          editMode
          marker={
            props.updatedKonteringsforslag._Associations?.Komponenttyp?.id !==
            props?.originKonteringsforslag?._Associations?.Komponenttyp?.id
          }
          fullWidth
          required={komponenttypField.obligatorisk}
          tooltip={komponenttypField.beskrivning}
          disabled={props.konteringsforslagDisabled}
          errorMessage={getErrorMessage(komponenttypField.fieldName)}
        />
      )}
      {avskrivningstidField?.aktiv && (
        <EditableAttribute
          collection={konteringsforslagModel}
          attribute={avskrivningstidAttribute}
          key={avskrivningstidField.fieldName}
          label={avskrivningstidField.benamning}
          onChange={props.onFieldValueChange(avskrivningstidField.fieldName)}
          value={(props.updatedKonteringsforslag as unknown as Record<string, ValueType>)[avskrivningstidField.fieldName]}
          editMode={true}
          marker={attrHasChanged(avskrivningstidField.fieldName)}
          required={avskrivningstidField.obligatorisk}
          tooltip={avskrivningstidField.beskrivning ?? undefined}
          disabled={props.konteringsforslagDisabled}
          errorMessage={getErrorMessage(avskrivningstidField.fieldName)}
        />
      )}
      {invdatumField?.aktiv && (
        <EditableAttribute
          collection={konteringsforslagModel}
          attribute={invdatumAttribute}
          key={invdatumField.fieldName}
          label={invdatumField.benamning}
          onChange={props.onFieldValueChange(invdatumField.fieldName)}
          value={(props.updatedKonteringsforslag as unknown as Record<string, ValueType>)[invdatumField.fieldName]}
          editMode={true}
          marker={attrHasChanged(invdatumField.fieldName)}
          required={invdatumField.obligatorisk}
          tooltip={invdatumField.beskrivning ?? undefined}
          disabled={props.konteringsforslagDisabled}
          errorMessage={getErrorMessage(invdatumField.fieldName)}
        />
      )}

      <EDRadioGroup
        label=""
        value={
          props.updatedKonteringsforslag?.AR_NY
            ? NewBuildingValues.new
            : NewBuildingValues.old
        }
        radioDefs={radioDefs}
        onChange={(newValue: string) => {
          const mappedValue = newValue as NewBuildingValues;
          if (dataForm) {
            dataForm.update([
              {
                operation: 'OwnFields',
                values: {
                  AR_NY: mappedValue === NewBuildingValues.new,
                },
              },
            ]);
          }
        }}
        paddingLeft="dense"
        marginTop="none"
        fullWidth
        row
        disabled={props.konteringsforslagDisabled}
      />

      {tillgangField?.aktiv && !isNewBuilding && (
        <AssociationChoice
          collectionName="ARTillgang"
          label={tillgangField.benamning}
          onAssociationSelected={suggestion => {
            if (dataForm) {
              const tillgang = props.data?.db?.ARTillgang_All?.find(
                tillgang => tillgang.id === suggestion?.value
              );

              let updates: FormUpdateAssociatonType[][] = [
                [
                  {
                    operation: 'Ref',
                    associationName: 'Tillgang',
                    values: suggestion
                      ? {
                          id: suggestion?.value,
                          RuleID: tillgang?.RuleID,
                        }
                      : null,
                  },
                ],
              ];

              if (suggestion) {
                updates.push([
                  {
                    operation: 'Ref',
                    associationName: 'Tillgang',
                  },
                  {
                    operation: 'Values',
                    associationName: 'Plats',
                    values: {
                      id: tillgang?._Associations?.Plats?.id,
                      PLATS_KOD: tillgang?._Associations?.Plats?.PLATS_KOD,
                      BENAMNING: tillgang?._Associations?.Plats?.BENAMNING,
                    },
                  },
                ]);
              }

              dataForm.update(updates);
            }
          }}
          value={
            props.updatedKonteringsforslag._Associations?.Tillgang?.id || ''
          }
          headerDefs={['ANLAGGNINGS_NR', 'BENAMNING']}
          editMode
          size="large"
          marker={
            props.updatedKonteringsforslag._Associations?.Tillgang?.id !=
            props?.originKonteringsforslag?._Associations?.Tillgang?.id
          }
          required={tillgangField.obligatorisk}
          tooltip={tillgangField.beskrivning}
          disabled={props.konteringsforslagDisabled}
          errorMessage={getErrorMessage(tillgangField.fieldName)}
          validValues={{
            urval: {
              pages: [
                {
                  id: shortid.generate(),
                  conditionObjects: [
                    {
                      modelPath: [rubrikAssociation],
                      attribute: arRubrikIdAttribute,
                      id: shortid.generate(),
                      type: 'String',
                      condition: [
                        {
                          id: shortid.generate(),
                          op: TEDSelectionOperator.equals,
                          values: [
                            {
                              id: shortid.generate(),
                              value:
                                props.updatedKonteringsforslag._Associations
                                  ?.Kontodel1?.KONTODEL,
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                {
                  id: shortid.generate(),
                  conditionObjects: [
                    {
                      modelPath: [rubrikAssociation],
                      attribute: arRubrikIdAttribute,
                      id: shortid.generate(),
                      type: 'String',
                      condition: [
                        {
                          id: shortid.generate(),
                          op: TEDSelectionOperator.starts,
                          values: [
                            {
                              id: shortid.generate(),
                              value:
                                props.updatedKonteringsforslag._Associations
                                  ?.Kontodel1?.KONTODEL === '1180'
                                  ? '11'
                                  : props.updatedKonteringsforslag._Associations
                                      ?.Kontodel1?.KONTODEL === '1280'
                                  ? '12'
                                  : 'x',
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          }}
          fullWidth
        />
      )}
      {tillgangField?.aktiv && isNewBuilding && (
        <EditableAttribute
          collection={konteringsforslagModel}
          attribute={tillgangbenamningAttribute}
          key={tillgangbenamningAttribute.AttributeName}
          label={tillgangField.benamning}
          onChange={props.onFieldValueChange(
            tillgangbenamningAttribute.AttributeName
          )}
          value={
            (props.updatedKonteringsforslag as unknown as Record<string, ValueType>)[
              tillgangbenamningAttribute.AttributeName
            ]
          }
          editMode={true}
          marker={attrHasChanged(tillgangbenamningAttribute.AttributeName)}
          required={tillgangField.obligatorisk}
          size="large"
          tooltip={'Ange benämning'}
          disabled={props.konteringsforslagDisabled}
          errorMessage={getErrorMessage(
            tillgangbenamningAttribute.AttributeName
          )}
        />
      )}
      {omradeField?.aktiv && (
        <ObjektLank
          collection={
            isNewBuilding ? konteringsforslagCollection : tillgangCollection
          }
          label={omradeField.benamning}
          onAssociationSelected={suggestion => {
            if (isNewBuilding && dataForm) {
              dataForm.update([
                {
                  operation: 'Ref',
                  associationName: 'Omrade',
                  id: suggestion?.value ?? '',
                  values: suggestion?.value
                    ? {
                        id: suggestion?.value,
                        ...suggestion?.data,
                      }
                    : null,
                },
              ]);
            }
          }}
          editMode={isNewBuilding}
          associationName={isNewBuilding ? 'Omrade' : 'Plats'}
          id={
            isNewBuilding
              ? props.updatedKonteringsforslag._Associations?.Omrade?.id ?? null
              : props.updatedKonteringsforslag._Associations?.Tillgang
                  ?._Associations?.Plats?.id ?? ''
          }
          data={
            isNewBuilding
              ? props.updatedKonteringsforslag
              : props.updatedKonteringsforslag._Associations?.Tillgang ??
                undefined
          }
          size="large"
          marker={
            isNewBuilding &&
            props.updatedKonteringsforslag._Associations?.Omrade?.id !=
              props?.originKonteringsforslag?._Associations?.Omrade?.id
          }
          required={omradeField.obligatorisk}
          tooltip={omradeField.beskrivning}
          headerDefs={['PLATS_KOD', 'BENAMNING']}
          disableAssociationLink
          disabled={props.konteringsforslagDisabled}
          errorMessage={getErrorMessage(omradeField.fieldName)}
          validValues={{
            urval: {
              pages: [
                {
                  id: shortid.generate(),
                  conditionObjects: [
                    {
                      modelPath: [],
                      attribute: platsTypAttribute,
                      id: shortid.generate(),
                      type: 'String',
                      condition: [
                        {
                          id: shortid.generate(),
                          op: TEDSelectionOperator.equals,
                          values: [
                            {
                              id: shortid.generate(),
                              value: 'F', // OMRADE
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          }}
          value={props.updatedKonteringsforslag._Associations?.Omrade?.id ?? ''}
          fullWidth
        />
      )}
      {avskrivningskontoField?.aktiv && (
        <div className={classes.avskrivsPaContainer}>
          <EDTypography className={classes.avskrivsPaLabel} bold>
            Avskrivs på
          </EDTypography>
          <div className={classes.avskrivsPaKoddelarContainer}>
            {avskrivningsKontoDelDefs.map(
              (
                avskrivningskontoDelDef,
                avskrivningsKontoDelDefIndex: number
              ) => {
                const updatedAvskrivningskontoDel:
                  | FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Konteringsforslag_All__Associations_Kontodel1
                  | undefined = isNewBuilding
                  ? (props.updatedKonteringsforslag._Associations as unknown as Record<string, unknown> | undefined)?.[
                      `AvskrKontodel${avskrivningskontoDelDef.ordningsNr}`
                    ] as FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Konteringsforslag_All__Associations_Kontodel1 | undefined
                  : (tillgangAvskrkontoDebQueryData?.db
                      ?.EKKonteringsvarde_All?.[0]?._Associations as unknown as Record<string, unknown> | undefined)?.[
                      `Kontodel${avskrivningskontoDelDef.ordningsNr}`
                    ] as FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Konteringsforslag_All__Associations_Kontodel1 | undefined;

                const originAvskrivningskontoDel:
                  | FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Konteringsforslag_All__Associations_Kontodel1
                  | undefined = isNewBuilding
                  ? (props?.originKonteringsforslag?._Associations as unknown as Record<string, unknown> | undefined)?.[
                      `AvskrKontodel${avskrivningskontoDelDef.ordningsNr}`
                    ] as FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Konteringsforslag_All__Associations_Kontodel1 | undefined
                  : undefined;

                const disabled =
                  props.konteringsforslagDisabled || !isNewBuilding;

                if (isNewBuilding) {
                  return (
                    <EDBox
                      sx={{
                        paddingRight:
                          avskrivningsKontoDelDefIndex === 0 && !isSmallScreen
                            ? 1
                            : 0,
                        paddingLeft:
                          avskrivningsKontoDelDefIndex === 1 && !isSmallScreen
                            ? 1
                            : 0,
                        width: isSmallScreen ? '100%' : '50%',
                        boxSizing: 'border-box',
                      }}
                      component="span"
                      key={avskrivningskontoDelDef.id}
                    >
                      <EDAutoCompleteEdit<IAvskrivningKontodelOption | null>
                        key={avskrivningskontoDelDef.id}
                        className={classes.avskrivsPaKoddel}
                        label={avskrivningskontoDelDef.namn}
                        value={
                          updatedAvskrivningskontoDel?.id
                            ? {
                                id: updatedAvskrivningskontoDel.id,
                                name: `${updatedAvskrivningskontoDel.KONTODEL} - ${updatedAvskrivningskontoDel.BENAMNING}`,
                                value: updatedAvskrivningskontoDel.KONTODEL,
                                benamning:
                                  updatedAvskrivningskontoDel.BENAMNING,
                              }
                            : null
                        }
                        disabled={disabled}
                        fullWidth
                        options={avskrivningskontoDelDef.kontodelar.map(
                          (kontodel: {
                            kontodel: string;
                            benamning: string | null;
                            id: string;
                          }) => ({
                            name: `${kontodel.kontodel} - ${kontodel.benamning}`,
                            value: kontodel.kontodel,
                            id: kontodel.id,
                            benamning: kontodel.benamning,
                          })
                        )}
                        getOptionLabel={option => {
                          return option?.name ?? '';
                        }}
                        getOptionSelected={option =>
                          avskrivningskontoDelDef.id === option?.id
                        }
                        onChange={(
                          option: IAvskrivningKontodelOption | null
                        ) => {
                          if (isNewBuilding && dataForm) {
                            dataForm.update([
                              {
                                operation: 'Ref',
                                associationName: `AvskrKontodel${avskrivningskontoDelDef.ordningsNr}`,
                                values: option?.id
                                  ? {
                                      id: option.id,
                                      KONTODEL: option.value,
                                      BENAMNING: option.benamning,
                                    }
                                  : null,
                              },
                            ]);
                          }
                        }}
                        marker={
                          !disabled &&
                          originAvskrivningskontoDel?.id !==
                            updatedAvskrivningskontoDel?.id
                        }
                        maxResult={50}
                        errorMessage={getErrorMessage(
                          avskrivningskontoField.fieldName,
                          avskrivningskontoDelDef.ordningsNr
                        )}
                        disableOpenOnFocus
                        required={avskrivningskontoField.obligatorisk}
                        addGutter
                      />
                    </EDBox>
                  );
                } else {
                  if (tillgangAvskrkontoDebQueryLoading) {
                    return null;
                  } else if (tillgangAvskrkontoDebQueryError) {
                    return (
                      <ServerError
                        key={avskrivningskontoDelDef.id}
                        error={tillgangAvskrkontoDebQueryError}
                      />
                    );
                  } else {
                    return (
                      <EDCaptionedValue
                        key={avskrivningskontoDelDef.id}
                        label={avskrivningskontoDelDef.namn}
                        name={avskrivningskontoDelDef.namn}
                        valueOnNewRow
                      >
                        <DisplayText
                          value={
                            updatedAvskrivningskontoDel
                              ? `${updatedAvskrivningskontoDel.KONTODEL} - ${updatedAvskrivningskontoDel.BENAMNING}`
                              : null
                          }
                          displayer={new TEDFormatDefault().displayer}
                          noValueChar="—"
                        />
                      </EDCaptionedValue>
                    );
                  }
                }
              }
            )}
          </div>
        </div>
      )}
      {kommentarField?.aktiv && (
        <EditableAttribute
          collection={konteringsforslagModel}
          attribute={kommentarAttribute}
          key={kommentarAttribute.AttributeName}
          label={kommentarField.benamning}
          onChange={props.onFieldValueChange(kommentarField.fieldName)}
          value={
            (props.updatedKonteringsforslag as unknown as Record<string, ValueType>)[kommentarAttribute.AttributeName]
          }
          editMode={true}
          multiline
          marker={attrHasChanged(kommentarAttribute.AttributeName)}
          required={kommentarField.obligatorisk}
          size="large"
          tooltip={kommentarField.beskrivning ?? undefined}
          disabled={props.konteringsforslagDisabled}
          errorMessage={getErrorMessage(kommentarField.fieldName)}
        />
      )}
    </>
  );
};

export default AdditionalInformation;
